import type { MutableRefObject } from 'react';

import { getSharedFooterProps } from './sharedFooterLogic';
import type { FooterProps, GenericItem } from '../types';

export const getSingleSelectionHandlers = <TItem extends GenericItem>({
  id,
  selectItem,
  closeMenu,
  refToFocusOnClear,
  selectedItem,
}: {
  id: string;
  selectItem: (item: TItem | null) => void;
  closeMenu: () => void;
  refToFocusOnClear: MutableRefObject<HTMLElement>;
  selectedItem: TItem | null;
}) => {
  const footerProps = getSharedFooterProps({
    id,
    reset: () => selectItem(null),
    closeMenu,
    refToFocusOnClear,
  });

  const getFooterProps: () => FooterProps = () => ({
    disableClear: !selectedItem,
    ...footerProps,
  });

  return {
    menuProps: {
      getFooterProps,
    },
  };
};
